import { notifyParent } from 'mailup-react-helpers'
import { useEffect } from 'react'

function useWindowLeaveGuard(allowCondition) {
  const handleBeforeUnload = (e) => {
    notifyParent('showLoadingMainFrame', [false])
    if (!allowCondition) {
      e.preventDefault()
      return (e.returnValue = '')
    } else {
      delete e.returnValue
    }
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload, {
      capture: true
    })

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload, {
        capture: true
      })
    }
  }, [allowCondition])
}

export default useWindowLeaveGuard
